<template>
  <div v-loading="pageLoading">
    <div>
      <el-form label-width="110px" :model="testPage">
        <el-form-item label="試卷名稱">
          <el-input
            v-model="testPage.testingName"
            type="textarea"
            :rows="3"
            style="width: 300px"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="試卷列表">
          <template>
            <div class="box">
              <div style="color: #d3dce6; font-size: 14px">
                正確答案點擊前面的單選按鈕
              </div>
              <div class="flex">
                <el-button
                  type="warning"
                  size="small"
                  @click="addQuestion(index++)"
                  >新增题目</el-button
                >
              </div>
            </div>
            <div class="box">
              <div
                v-for="(item, index) in tableData"
                :key="item.id"
                class="flex"
              >
                <el-form-item label="題目" label-width="50px">
                  <el-tooltip
                    class="item"
                    popper-class="popper"
                    effect="light"
                    :disabled="!item.content"
                    :content="item.content"
                    placement="top"
                  >
                    <el-input v-model="item.content"></el-input>
                  </el-tooltip>
                </el-form-item>
                <div class="grid">
                  <el-radio v-model="item.answer" label="A"></el-radio>
                  <el-input v-model="item.optionA"></el-input>
                </div>
                <div class="grid">
                  <el-radio v-model="item.answer" label="B"></el-radio>
                  <el-input v-model="item.optionB"></el-input>
                </div>
                <div class="grid">
                  <el-radio v-model="item.answer" label="C"></el-radio>
                  <el-input v-model="item.optionC"></el-input>
                </div>
                <div class="grid">
                  <el-radio v-model="item.answer" label="D"></el-radio>
                  <el-input v-model="item.optionD"></el-input>
                </div>
                <el-form-item label="分數" label-width="50px">
                  <el-input
                    type="number"
                    oninput="value=value.replace(/^\.+|[^\d.]/g,'')"
                    style="width: 70px"
                    v-model="item.score"
                  ></el-input>
                </el-form-item>
                <el-form-item label-width="25px">
                  <el-button
                    type="warning"
                    size="small"
                    @click="removeQuestion(index)"
                    >移除题目</el-button
                  >
                </el-form-item>
              </div>
            </div>
          </template>
        </el-form-item>
        <el-form-item label="合格線">
          <el-input v-model="testPage.qualified"></el-input>
        </el-form-item>
        <el-form-item label="是否強制答題">
          <el-radio-group v-model="testPage.forcedAnswer">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$emit('back')">取 消</el-button>
        <el-button type="primary" @click="addTestPage">確 定</el-button>
      </div>
      <el-button class="btn" @click="back()">返 回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageLoading: false,

      testPage: {
        qualified: "60",
        testingName: "",
        forcedAnswer: "1",
      },
      tableData: [],
      index: 1,
      courseType: false,
      id: "",
      totalScore: 0,
    };
  },
  mounted() {
    $("#pageHead").text("題庫設置");
  },
  methods: {
    addQuestion(i) {
      let table = this.tableData;
      if (table.length < 10) {
        // table.push({
        // 	optionA: '',
        // 	optionB: '',
        // 	optionC: '',
        // 	optionD: '',
        // 	content: '',
        // 	answer: 'A',
        // 	score: 10,
        // 	id: 2
        // });
        table.splice(i + 1, 0, {
          optionA: "",
          optionB: "",
          optionC: "",
          optionD: "",
          content: "",
          answer: "A",
          score: "",
          id: i,
        });
      } else {
        this.$message({
          type: "warning",
          message: "已到題目設置上限",
        });
        return;
      }
    },
    removeQuestion(index) {
      let table = this.tableData;
      if (table.length > 1) {
        table.splice(index, 1);
      } else {
        this.$message({
          type: "warning",
          message: "至少保留一條題目",
        });
        return;
      }
    },
    addTestPage() {
      // 提交題目
      var testPage = JSON.parse(JSON.stringify(this.testPage));
      if (testPage.testingName == "") {
        this.$message({
          type: "warning",
          message: "請將填寫試卷名稱",
        });
        return;
      }
      let tableData = this.tableData;
      if (this.tableData.length == 0) {
        this.$message({
          type: "warning",
          message: "請新增題目",
        });
        return;
      }
      let bool = tableData.every((items) => {
        for (let item in items) {
          return items[item];
        }
      });

      if (!bool) {
        this.$message({
          type: "warning",
          message: "請將題目填寫完整",
        });
        return;
      }

      let totalScore = 0;
      tableData.forEach((item) => {
        totalScore += parseInt(item.score);
      });
      this.totalScore = totalScore;

      if (this.totalScore != 100) {
        this.$message({
          type: "warning",
          message: "總分數應為100",
        });
        return;
      }

      if (testPage.qualified == "") {
        this.$message({
          type: "warning",
          message: "請將填寫試卷合格線",
        });
        return;
      }
      var qualified = /^\d{1,3}$/;
      if (!qualified.test(testPage.qualified)) {
        this.$message({
          type: "warning",
          message: "請將填寫正確的合格線",
        });
        return;
      }
      var table = JSON.stringify(tableData);
      var that = this;
      var url = "";
      if (this.id) {
        // 修改
        let type = 0;
        if (this.courseType == "offline") {
          type = 2;
        } else if (this.courseType == "online") {
          type = 1;
        } else if (this.courseType == "live") {
          type = 3;
        }
        testPage["manOnlineYtopics"] = table;
        testPage["type"] = type;
        testPage["id"] = this.id;

        this.pageLoading = true
        this.axios
          .post("/manage/updateManTesting", this.qs.stringify(testPage))
          .then(res => {
            if (res) {
              that.$message({
                message: "修改成功",
                type: "success",
              });

              sessionStorage.questionMsg = JSON.stringify({
                id: that.id,
                name: testPage.testingName,
              });
              setTimeout(()=> {
                that.$emit("back");
              }, 1000);
            } else {
              this.pageLoading = false
            }
          }).catch(() => {
            this.pageLoading = false
          })
      } else {
        // 新增
        if (this.courseType == "offline") {
          url = "/manage/addManOfflineTesting";
          testPage["manOfflineYtopics"] = table;
        } else if (this.courseType == "online") {
          url = "/manage/addManOnlineTesting";
          testPage["manOnlineYtopics"] = table;
        } else if (this.courseType == "live") {
          url = "/manage/addManLiveTesting";
          testPage["manLiveYtopics"] = table;
        }
        
        this.pageLoading = true
        this.axios.post(url, this.qs.stringify(testPage)).then(res => {
          if (res.code == 200) {
            this.$message({
              message: "新增成功",
              type: "success",
            });
            sessionStorage.questionMsg = JSON.stringify({
              id: res.message,
              name: testPage.testingName,
            });
            setTimeout(() => {
              this.$emit("back");
            }, 500);
           
          } else {
            this.pageLoading = false
            this.$message.error(res.message);
          }
        }).catch(() => {
          this.pageLoading = false
        })
      }
    },
    back() {
      var bool = false;
      this.tableData.forEach((k) => {
        // eslint-disable-line no-unused-vars
        if (k.content) {
          bool = true;
        }
      });
      if (this.testPage.testingName || bool) {
        this.$confirm("資料尚未儲存，確定離開?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$emit("back");
          })
          .catch(() => {});
      } else {
        this.$emit("back");
      }
    },
  },
  created() {
    this.courseType = sessionStorage.getItem("courseType");
    let questionSet = sessionStorage.getItem("questionSet");
    if (questionSet) {
      let msg = JSON.parse(questionSet);
      this.testPage.testingName = msg.name;
      this.id = msg.id;
      let type = 0;
      if (this.courseType == "offline") {
        type = 2;
      } else if (this.courseType == "online") {
        type = 1;
      } else if (this.courseType == "live") {
        type = 3;
      }
      this.pageLoading = true
      this.axios({
        url: "/manage/getOnlineEchoBank",
        params: {
          id: this.id,
          type,
        },
      }).then((res) => {
        if (res) {
          let resd = res.result;
          resd.list.forEach((line, index) => {
            line.id = index
          })
          this.tableData = resd.list;
          this.index = this.tableData.length
          this.testPage.qualified = resd.qualified;
          this.testPage.forcedAnswer = resd.forced_answer + "";
          this.pageLoading = false
        }
      });
    } else {
      let table = this.tableData;
      for (var i = 0; i < 1; i++) {
        table.push({
          optionA: "",
          optionB: "",
          optionC: "",
          optionD: "",
          content: "",
          answer: "A",
          score: "",
          id: i,
        });
      }
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("questionSet");
  },
};
</script>

<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}

.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.box {
  max-width: 100%;
  overflow-x: scroll;
}
.flex {
  display: flex;
  margin-bottom: 8px;
}
.grid {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
</style>